'use strict';
import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from './navBar';
import SideMenu from './sideMenu';
import leaveAction from '../actions/leaveAction';
import leaveStore from '../stores/leaveStore';
import menuAction from '../actions/menuAction';
import modalAction from '../actions/modalAction';
import filterAction from '../actions/filterAction';
import filterStore from '../stores/filterStore';
import Loading from './loading';
import genFunction from '../functions/genFunction';

class LeaveApply extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.onFilterChange = this.onFilterChange.bind(this);
        this.upLoadImg = this.upLoadImg.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleTimeEdit = this.handleTimeEdit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.clear = this.clear.bind(this);
        this.state = {
            processing: leaveStore.getState().processing,
            summary: leaveStore.getState().summary.summary,
            isLeaveSuccess: leaveStore.getState().isLeaveSuccess,
            filterProcessing: filterStore.getState().processing,
            iniLoadHoliday: filterStore.getState().iniLoadHoliday,
            holiday: filterStore.getState().holiday,
            leave: {
                type: 0,
                startYear: 0,
                startMonth: 0,
                startDate: 0,
                endYear: 0,
                endMonth: 0,
                endDate: 0,
                apmStart: 0,
                apmEnd: 0,
                startTime: "",
                endTime: "",
                duration: 0,
                reason: "",
                leaveImage: "",
            }
        };
    }
    static defaultProps = {
        apmTxt: ["Full Day", "AM", "PM"]
    }

    componentDidMount() {
        leaveStore.listen(this.onChange);
        filterStore.listen(this.onFilterChange);
        if (!this.state.processing) {
            leaveAction.processing(true);
            leaveAction.getSummary(this.props.match.params.staffId);
            leaveAction.isLeaveSuccess(false);
        }
        if (!this.state.filterProcessing && !this.state.iniLoadHoliday) {
            filterAction.processing(true);
            filterAction.getHoliday();
        }

        menuAction.pageNumber.defer(-1);
    }
    componentWillUnmount() {
        leaveStore.unlisten(this.onChange);
        filterStore.unlisten(this.onFilterChange);
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.isLeaveSuccess && prevState.isLeaveSuccess != this.state.isLeaveSuccess) {
            window.setTimeout(() => {
                window.location.reload();
            }, 3000);
        }
    }
    clear() {
        this.setState({
            leave: {
                type: 0,
                startYear: 0,
                startMonth: 0,
                startDate: 0,
                endYear: 0,
                endMonth: 0,
                endDate: 0,
                apmStart: 0,
                apmEnd: 0,
                duration: 0,
                reason: ""
            }
        });
    }
    onFilterChange(state) {
        this.setState({
            filterProcessing: state.processing,
            iniLoadHoliday: state.iniLoadHoliday,
            holiday: state.holiday,
        })
    }
    onChange(state) {
        this.setState({
            processing: state.processing,
            summary: state.summary.summary,
            isLeaveSuccess: state.isLeaveSuccess,
        });
    }
    upLoadImg(e) {
        let index = parseInt(e.target.getAttribute("data-index"));
        let file = e.target.files[0];
        this._previewImage(file, index);
    }
    handleChange(e) {
        let index = parseInt(e.target.getAttribute("data-index"));
        let s = this.state.leave;
        if (index == 0) {
            //type
            s.type = parseInt(e.target.value);
        } else if (index == 2) {
            s.apmStart = parseInt(e.target.value);
        } else if (index == 4) {
            s.apmEnd = parseInt(e.target.value);
        }

        this.setState({
            leave: s
        });
        this.calculateDuration();
    }
    handleTimeEdit(e) {
        let index = parseInt(e.target.getAttribute("data-index"));
        let s = this.state.leave;
        if (index == 7) {
            s.startTime = e.target.value;
        } else if (index == 8) {
            s.endTime = e.target.value;
        }

        this.setState({ leave: s });
        this.calculateDuration();
    }
    handleEdit(e) {
        let index = parseInt(e.target.getAttribute("data-index"));
        let s = this.state.leave;
        let data;
        if (index == 1) {
            data = e.target.value.split("-");
            s.startYear = parseInt(data[0]);
            s.startMonth = parseInt(data[1]) - 1;
            s.startDate = parseInt(data[2]);
        } else if (index == 3) {
            data = e.target.value.split("-");
            s.endYear = parseInt(data[0]);
            s.endMonth = parseInt(data[1]) - 1;
            s.endDate = parseInt(data[2]);

        } else if (index == 5) {
            data = e.target.value;
            s.reason = data;
        }
        this.setState({ leave: s });
        this.calculateDuration();
    }
    isHoliday(year, month, date) {
        let isHoliday = false;
        if (this.state.holiday) {
            if (this.state.holiday.holiday) {
                let s = this.state.holiday;
                let len = s.holiday.length;
                for (let i = 0; i < len; i++) {
                    if (s.holiday[i].year == year && s.holiday[i].month == month && s.holiday[i].date == date) {
                        isHoliday = true;
                        break;
                    }
                }

            }
        }

        return isHoliday;
    }
    calculateDuration() {
        let s = this.state.leave;
        if (s.startYear != 0 && s.endYear != 0) {
            let sDate = new Date(s.startYear, s.startMonth, s.startDate);
            let eDate = new Date(s.endYear, s.endMonth, s.endDate);
            let duration = 0;


            //if start and end are same day
            if (s.startYear == s.endYear && s.startMonth == s.endMonth && s.startDate == s.endDate) {
                s.apmEnd = 0;
            }


            let noDays = parseInt(eDate.getTime() - sDate.getTime()) / 1000 / 60 / 60 / 24 + 1;
            if (noDays > 0) {
                for (let j = 0; j < noDays; j++) {
                    let day = new Date(s.startYear, s.startMonth, s.startDate + j).getDay();
                    let isHoliday = this.isHoliday(s.startYear, s.startMonth, s.startDate + j);
                    if (isHoliday) {

                    } else if (j == 0 && day == 6) {
                        if (this.state.holiday.saturdayWork == 0) {
                            if (s.apmStart == 1 || s.apmStart == 2) {
                                duration += 0.5;
                            } else {
                                duration += 1;
                            }
                        } else if (this.state.holiday.saturdayWork == 1) {
                            duration += 0.5;
                            s.apmStart = 1;
                        } else if (this.state.holiday.saturdayWork == 2) {
                            s.apmStart = 0;
                        }

                    } else if (j == 0 && day == 0) {
                        //sun
                        s.apmStart = 0;
                    } else if (j == 0 && (s.apmStart == 1 || s.apmStart == 2)) {
                        duration += 0.5;
                    } else if (j == 0 && (s.apmStart == 0)) {
                        duration += 1;
                    } else if (j + 1 == noDays && day == 6) {
                        if (this.state.holiday.saturdayWork == 0) {
                            if (s.apmEnd == 1 || s.apmEnd == 2) {
                                duration += 0.5;
                            } else {
                                duration += 1;
                            }
                        } else if (this.state.holiday.saturdayWork == 1) {
                            duration += 0.5;
                            s.apmEnd = 1;
                        } else if (this.state.holiday.saturdayWork == 2) {
                            s.apmEnd = 1;
                        }
                    } else if (j + 1 == noDays && day == 0) {
                        s.apmEnd = 0;
                    } else if (j + 1 == noDays && (s.apmEnd == 1 || s.apmEnd == 2)) {
                        duration += 0.5;
                    } else if (j == 0 && (s.apmEnd == 0)) {
                        duration += 1;
                    } else if (day == 6) {
                        if (this.state.holiday.saturdayWork == 0) {
                            duration += 1;
                        } else if (this.state.holiday.saturdayWork == 1) {
                            duration += 0.5;
                        }
                    } else if (day == 0) {
                    } else {
                        duration += 1;
                    }
                }
            }

            //if end date less than start date
            if (noDays <= 0) {
                modalAction.modalContent({ title: "Warning", content: "End Date must be greater than start Date" });
                modalAction.modalClose(true);
                s.endYear = 0;
                s.endMonth = 0;
                s.endDate = 0;
                s.apmEnd = 0;
                this.setState({ leave: s });
                return;
            }
            //s.duration = duration - minus;
            s.duration = duration
            this.setState({ leave: s });
        } else if (s.type == 7) {

            if (s.startTime && s.endTime) {
                let sDate = new Date(s.startYear, s.startMonth, s.startDate, parseInt(s.startTime.split(":")[0]), parseInt(s.startTime.split(":")[1]));
                let eDate = new Date(s.startYear, s.startMonth, s.startDate, parseInt(s.endTime.split(":")[0]), parseInt(s.endTime.split(":")[1]));
                let duration = 0;
                let isHoliday = this.isHoliday(s.startYear, s.startMonth, s.startDate);
                if (!isHoliday) {
                    duration = (eDate.getTime() - sDate.getTime()) / 1000 / 60 / 60;

                    if (duration <= 0) {
                        modalAction.modalContent({ title: "Warning", content: "End Time must be greater than Start Time" });
                        modalAction.modalClose(true);
                        s.endTime = "";
                        duration = 0;
                    }
                }
                s.duration = duration;
            }

            this.setState({ leave: s });
        }
    }
    _previewImage(file, index) {

        //to be modified
        let fr = new FileReader();
        fr.onload = (e) => {
            let imgUrl = window.URL.createObjectURL(new Blob([e.target.result]));
            let img = new Image();

            img.onload = () => {
                this.resizeImage(img, index);
            }

            img.src = imgUrl;
        }
        fr.readAsArrayBuffer(file);
    }
    resizeImage(image, index) {
        let oHeight = image.naturalHeight;
        let oWidth = image.naturalWidth;
        let newImage, newSize;
        let oSize = { oHeight: oHeight, oWidth: oWidth };
        newSize = { width: 500, height: 500 * oHeight / oWidth };

        newImage = this._imgResize(image, newSize, oSize);
        let blobFile = this.dataURItoBlob(newImage);
        let leave = this.state.leave;
        if (index == 0) {
            leave.leaveImage = blobFile;
        } else if (index == 1) {
            leave.receiptImage = blobFile;
        }
        this.setState({ leave: leave });
    }
    dataURItoBlob(dataURI) {
        var byteString;
        if (dataURI.split(',')[0].indexOf('base64') >= 0)
            byteString = window.atob(dataURI.split(',')[1]);
        else
            byteString = unescape(dataURI.split(',')[1]);

        // separate out the mime component
        var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

        // write the bytes of the string to a typed array
        var ia = new Uint8Array(byteString.length);
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }

        return new Blob([ia], { type: mimeString });
    }
    _imgResize(img, newSize, oSize) {
        let canvas = document.createElement('canvas');
        let ctx = canvas.getContext("2d");
        canvas.width = newSize.width;
        canvas.height = newSize.height;
        ctx.drawImage(img, 0, 0, oSize.oWidth, oSize.oHeight, 0, 0, newSize.width, newSize.height);
        return canvas.toDataURL('image/jpeg', 1);
    }
    handleSubmit() {
        //check available
        let s = this.state.leave;
        let available;
        let len = this.state.summary.length;
        let summary = this.state.summary;
        if (s.type != 7) {
            if (s.startYear == 0 || s.startDate == 0 || s.endYear == 0 || s.endDate == 0) {
                //show warning
                modalAction.modalContent({ title: "Warning", content: "Please select Date" });
                modalAction.modalClose(true);
                return;
            }
        } else if (s.type == 7) {
            if (s.startYear == 0 || s.startDate == 0 || s.startTime == "" || s.endTime == "") {
                //show warning
                modalAction.modalContent({ title: "Warning", content: "Please fill up Start Date, Start Time and End Time" });
                modalAction.modalClose(true);
                return;
            }
        }

        for (let i = 0; i < len; i++) {
            if (s.type == 0 && s.type == summary[i].type) {
                available = summary[i].leaveGain + summary[i].bringFwd - summary[i].used;
            } else if (s.type == 9 && s.type == summary[i].type) {
                let annualTotalAvail = this.findAnnualTotalAvail();
                available = Math.min(annualTotalAvail, summary[i].totalGain - summary[i].used);
            } else if (s.type != 4 && s.type != 6 && s.type == summary[i].type) {
                available = summary[i].totalGain - summary[i].used;
            }
        }
        if (s.type != 4 && s.type != 6) {
            console.log(available);
            if (available < s.duration) {
                //show warning
                modalAction.modalContent({ title: "Warning", content: "Your leave balance is not enough" });
                modalAction.modalClose(true);
                return;
            }
        } else if (s.reason == "") {
            modalAction.modalContent({ title: "Warning", content: "Reason is needed for unpaid leave or other leave" });
            modalAction.modalClose(true);
            return;
        }
        //submit
        let fd = new FormData();
        if (s.leaveImage) {
            fd.append("images", s.leaveImage);
        }
        if (s.receiptImage) {
            fd.append("receipt", s.receiptImage);
        }
        fd.append("type", s.type);
        fd.append("startYear", s.startYear);
        fd.append("startMonth", s.startMonth);
        fd.append("startDate", s.startDate);
        fd.append("endYear", s.endYear);
        fd.append("endMonth", s.endMonth);
        fd.append("endDate", s.endDate);
        fd.append("apmStart", s.apmStart);
        fd.append("apmEnd", s.apmEnd);
        fd.append("duration", s.duration);
        fd.append("reason", s.reason);
        fd.append("startTime", s.startTime);
        fd.append("endTime", s.endTime);

        leaveAction.processing(true);
        leaveAction.applyLeave(fd);
        this.clear();
    }
    findAnnualTotalAvail() {
        let annualTotalAvail = 0;
        let month = new Date().getMonth();
        let summary = this.state.summary;
        //need to loop to find
        for (let i = 0; i < summary.length; i++) {
            if (summary[i].type == 0) {
                let remainingDays = (11 - month) * (summary[i].totalGain) / 11;
                annualTotalAvail = remainingDays + summary[i].leaveGain + summary[i].bringFwd - summary[i].used;
                break;
                //annualTotalAvail = this.state.summary[i].totalGain + this.state.summary[i].bringFwd - this.state.summary[i].used;
            }
        }
        return annualTotalAvail;
    }
    renderType() {
        let annualTotalAvail = 0;
        if (this.state.summary) {
            return this.state.summary.map((summary, index) => {
                let available;
                if (summary.type == 0) {
                    available = summary.leaveGain + summary.bringFwd - summary.used;
                } else if (summary.type == 9) {
                    annualTotalAvail = this.findAnnualTotalAvail();
                    available = Math.min(annualTotalAvail, summary.totalGain - summary.used);
                } else if (summary.type != 4 && summary.type != 6) {
                    available = summary.totalGain - summary.used;
                } else if (summary.type == 4 || summary.type == 6) {
                    return (<option value={summary.type} key={index}>{summary.leaveTxt}</option>);
                }

                if (summary.type == 7) {
                    return (<option value={summary.type} key={index}>{summary.leaveTxt} ({available + (available <= 1 ? " hour" : " hours")})</option>);
                }
                return (<option value={summary.type} key={index}>{summary.leaveTxt} ({available + (available <= 1 ? " day" : " days")})</option>);
            });
        }
    }
    renderAPM() {
        let index = [0, 1, 2];
        return index.map((index) => {
            return (
                <option value={index} key={index}>{this.props.apmTxt[index]}</option>
            );
        });
    }
    render() {
        let s = this.state.leave;
        let sDate = "";
        let eDate = "";
        if (s.startDate != 0) {
            let startDate = s.startDate < 10 ? "0" + s.startDate : s.startDate;
            let startMonth = s.startMonth + 1 < 10 ? "0" + (s.startMonth + 1) : (s.startMonth + 1);
            sDate = s.startYear + "-" + startMonth + "-" + startDate;
        }
        if (s.endDate != 0) {
            let endDate = s.endDate < 10 ? "0" + s.endDate : s.endDate;
            let endMonth = s.endMonth + 1 < 10 ? "0" + (s.endMonth + 1) : (s.endMonth + 1);
            eDate = s.endYear + "-" + endMonth + "-" + endDate;
        }

        return (
            <div>
                <Navbar {...this.props} />
                <div className="container-fluid content">
                    <div className="row">
                        <SideMenu {...this.props} />
                        <div className=" col-md-10  col-sm-8 atd">
                            <div className="row">
                                <div className="col-md-4">
                                    <h4><b>Apply Leave</b></h4>
                                    <div className="form-group">
                                        <label htmlFor="type">Type</label>
                                        <select className="form-control atd-sel" name="type" data-index="0"
                                            onChange={this.handleChange} value={s.type}>
                                            {this.renderType()}
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="startDate">Start Date</label>
                                        <input type="date" className="form-control" value={sDate} id="startDate"
                                            placeholder="Pick a date" data-index="1" onChange={this.handleEdit} />
                                    </div>
                                    {s.type != 7 ?
                                        <div>
                                            <div className="form-group">
                                                <label htmlFor="apmStart">AM/PM</label>
                                                <select className="form-control atd-sel" name="apmStart" data-index="2"
                                                    onChange={this.handleChange} value={s.apmStart}>
                                                    {this.renderAPM()}
                                                </select>
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="endDate">End Date</label>
                                                <input type="date" className="form-control" value={eDate} id="endDate"
                                                    placeholder="Pick a date" data-index="3" onChange={this.handleEdit}
                                                    disabled={s.startDate == 0} />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="apmEnd">AM/PM</label>
                                                <select className="form-control atd-sel" name="apmEnd" data-index="4"
                                                    onChange={this.handleChange} value={s.apmEnd}
                                                    disabled={s.endDate == 0 || (s.startDate == s.endDate &&
                                                        s.startMonth == s.endMonth && s.startYear == s.endYear)}>
                                                    {this.renderAPM()}
                                                </select>
                                            </div>
                                        </div>
                                        :
                                        <div>
                                            <div className="form-group">
                                                <label htmlFor="endDate">Start Time</label>
                                                <input type="time" className="form-control" value={s.startTime} id="startTime"
                                                    data-index="7" onChange={this.handleTimeEdit}
                                                    disabled={s.startDate == 0} />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="endTime">End Time</label>
                                                <input type="time" className="form-control" value={s.endTime} id="endTime"
                                                    data-index="8" onChange={this.handleTimeEdit}
                                                    disabled={s.startDate == 0} step="1800" />
                                            </div>
                                        </div>
                                    }
                                    <div className="form-group">
                                        <label htmlFor="reason">Reason</label>
                                        <textarea rows="3" name="reason" onChange={this.handleEdit} data-index="5" value={s.reason}
                                            style={{ width: "100%", resize: "none" }} step="1800" />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="duration">Duration ({s.type == 7 ? "hour" : "day"})</label>
                                        <input type="number" className="form-control" value={s.duration} id="endDate"
                                            placeholder="duration" data-index="6" onChange={this.handleEdit}
                                            disabled={true} />
                                    </div>
                                    {s.type == 1 ?
                                        <div>
                                            <div className="form-group">
                                                <label htmlFor="uploadMC">Upload MC</label>
                                                <input type="file" name="uploadMC" accept="image/*" data-index="0" onChange={this.upLoadImg} />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="uploadMC">Upload Receipt</label>
                                                <input type="file" name="uploadMC" accept="image/*" data-index="1" onChange={this.upLoadImg} />
                                            </div>
                                        </div>
                                        : ""}

                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4">
                                    <button className="btn btn-default" onClick={this.handleSubmit}>Apply</button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <Loading processing={this.state.processing || this.state.filterProcessing} />
            </div>
        );
    }
}
export default LeaveApply;


// WEBPACK FOOTER //
// ./app/components/leaveApply.js